import Attachment from './types/attachment';
import Choice from './types/choice';
import DateItem from './types/date';
import Decimal from './types/decimal';
import Integer from './types/integer';
import type { QuestionnaireItemProps } from './types/item-props';
import OpenChoice from './types/openchoice';
import String from './types/string';

export default function QuestionnaireItem(props: QuestionnaireItemProps) {
  // props: question, addAnswer, i, j, currentAnswer, enable
  switch (props.question.type) {
    case 'display':
      return <></>;
    case 'string':
      return (
        <String
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
          question={props.question}
          answersStateReady={props.answersStateReady}
          allReferralData={props?.allReferralData}
          practitionerData={props.practitionerData}
          tasksData={props?.tasksData}
          surveyStatus={props?.surveyStatus}
          questionnaireResponseData={props?.questionnaireResponseData}
          currentQrId={props?.currentQrId}
          excludePractitionerId={props?.excludePractitionerId}
          disableCosignPractitioner={props?.disableCosignPractitioner}
        />
      );
    case 'text':
      return (
        <String
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
          question={props.question}
          answersStateReady={props.answersStateReady}
          allReferralData={props?.allReferralData}
          practitionerData={props.practitionerData}
          tasksData={props?.tasksData}
          surveyStatus={props?.surveyStatus}
          questionnaireResponseData={props?.questionnaireResponseData}
          currentQrId={props?.currentQrId}
          excludePractitionerId={props?.excludePractitionerId}
          disableCosignPractitioner={props?.disableCosignPractitioner}
        />
      );
    case 'integer':
      return (
        <Integer
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
        />
      );
    case 'decimal':
      return (
        <Decimal
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
        />
      );
    case 'date':
      return (
        <DateItem
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          question={props.question}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
          answersStateReady={props.answersStateReady}
        />
      );
    case 'choice':
      return (
        <Choice
          question={props.question}
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
          language={props.language}
        />
      );
    case 'open-choice':
      return (
        <OpenChoice
          question={props.question}
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
          language={props.language}
        />
      );
    case 'attachment':
      return (
        <Attachment
          question={props.question}
          addAnswer={props.addAnswer}
          i={props.i}
          j={props.j}
          currentAnswer={props.currentAnswer}
          enable={props.enable}
          language={props.language}
          surveyImage={props.surveyImage}
        />
      );
    default:
      return <></>;
  }
}
